import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Path } from 'constants/router'

import { usePfStore } from '../store'
import { useStripeRedirectHandler } from './useStripeRedirectHandler'

/**
 * Settles a return from a Stripe redirect onto the flow.
 *
 * A paid order leaves for the dashboard, or inside the Propstack embed goes terminal, since the dashboard
 * is a main-app route the iframe must never load. A failed payment only needs handling in the embed: the
 * main app returns to the payment status page, while the embed returns here, to a flow the reload emptied.
 *
 * @returns Whether the embed must show that the payment failed.
 */
export function useStripeReturn(isEmbed: boolean): { isEmbedPaymentFailed: boolean } {
  const navigate = useNavigate()
  const [isEmbedPaymentFailed, setIsEmbedPaymentFailed] = useState(false)

  const onSuccess = useCallback(() => {
    if (isEmbed) {
      usePfStore.getState().setOrderPlaced()
      return
    }
    navigate(Path.INDEX)
  }, [isEmbed, navigate])

  const onError = useCallback(() => {
    if (isEmbed) setIsEmbedPaymentFailed(true)
  }, [isEmbed])

  useStripeRedirectHandler({ onSuccess, onError })

  return { isEmbedPaymentFailed }
}
